var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-name":"facebook 16px","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 8a8 8 0 1 0-9.25 7.9v-5.59H4.72V8h2.03V6.24a2.82 2.82 0 0 1 3.02-3.12 12.3 12.3 0 0 1 1.8.16v1.97h-1.02a1.16 1.16 0 0 0-1.3 1.25V8h2.22l-.36 2.31H9.25v5.59A8 8 0 0 0 16 8Z","fill":"#fefefe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }